import { z } from "zod";

import { zOrderNumber } from "./order-number";
import { zRatingSchema } from "./rating";

import { UserEntity } from "~/entities/user/@x/review";
import { zEmptyString } from "~/shared/zod";

const zSchema = z.object({
  id: z.string().uuid(),
  rating: zRatingSchema,
  pros: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 9),
  cons: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 9),
  text: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 10),
  customer: UserEntity.zSchema
    .pick({
      firstName: true,
      lastName: true,
    })
    .extend({
      email: z.union([zEmptyString, UserEntity.zSchema.shape.email]),
      phone: z.union([zEmptyString, UserEntity.zSchema.shape.phone]),
    }),
  isApproved: z.boolean(),
  createdAt: z.date(),
  orderNumber: zOrderNumber,
});

type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
